import {InputDate} from "../../../_services/date-extensions";
import {EventRepetitionModel} from "./event-repetition-model";
import {EventOptionsModel} from "./event-options-model";
import {LocationDto} from "../../../models/location-dto";
import {EventKind} from "../../../enums/event-kind";

export class EventNewModel {
  name: string = "";
  start: InputDate = new InputDate();
  end: InputDate = new InputDate();

  /**
   * "Art des Events" (#664) — what the creation form's picker holds. Resets to {@link EventKind.Real} with the
   * rest of the form, and is overwritten by the allowance whenever the contract leaves only one choice.
   */
  kind: EventKind = EventKind.Real;

  constructor() {
    this.start.setMinutes(0, 0, 0);
    this.end.setTime(this.start.getTime() + (12 * 60 * 60 * 1000));
  }

  repetition: EventRepetitionModel | undefined;

  repetitionAdd() {
    this.repetition ??= new EventRepetitionModel();
  }

  repetitionRemove() {
    this.repetition = undefined;
  }

  options: EventOptionsModel | undefined;

  optionsAdd() {
    this.options ??= new EventOptionsModel();
  }

  optionsRemove() {
    this.options = undefined;
  }

  configurations: { [key: string]: string | undefined } | undefined;

  configurationsAdd() {
    this.configurations ??= {};
  }

  configurationsRemove() {
    this.configurations = undefined;
  }

  allConfigurations: string | undefined;

  setConfigurations(locations: LocationDto[] | undefined, configuration: string | undefined) {
    this.configurations = {};
    if (locations === undefined) return;

    for (const location of locations) {
      this.configurations[location.id] = configuration;
    }

    setTimeout(() => {
      this.allConfigurations = undefined;
    })
  }

  setConfiguration(location: string, configuration: string | undefined) {
    if (this.configurations === undefined || configuration != undefined) return;
    delete this.configurations[location];
  }
}
